import { Component } from '@theme/component';

export class ProductSizeGuideComponent extends Component {
  requiredRefs = [
    'popup',
    'openButton',
    'closeButton',
  ];

  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#abortController;

    document.addEventListener(
      'click',
      this.#handleOutsideClick,
      { signal }
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#abortController.abort();
  }

  openSizeModal() {
    document.body.style.width = '100%';
    document.body.style.position = 'fixed';

    this.refs.popup.showModal();

    // this.refs.popup.classList.add('ms-open');
    // this.refs.popup.setAttribute('aria-hidden', 'false');

    // this.refs.closeButton.classList.add('ms-visible');
    // this.refs.triggerButton.classList.add('ms-hidden');
  }

  closeSizeModal() {
    document.body.style.width = 'auto';
    document.body.style.position = 'relative';

    this.refs.popup.close();
  }

  #handleOutsideClick = (event) => {
    if (
      this.refs.popup.classList.contains('amn-size') &&
      !this.contains(event.target)
    ) {
      this.closeSizeModal();
    }
  };
}

if (!customElements.get('product-size-guide')) {
  customElements.define(
    'product-size-guide',
    ProductSizeGuideComponent
  );
}
